module.exports = __webpack_public_path__ + "img/255.lapel_pin.327fe0fe.svg";